import firebase from 'firebase'
const config = {
  apiKey: "AIzaSyASCRemuZ__6SVzm_LpD8138CvVDW9Jayk",
  authDomain: "ag-tronix-weather.firebaseapp.com",
  databaseURL: "https://ag-tronix-weather.firebaseio.com",
  projectId: "ag-tronix-weather",
  storageBucket: "ag-tronix-weather.appspot.com",
  messagingSenderId: "401335925678",
  appId: "1:401335925678:web:094187376a2c5852"
};
export const firebaseApp = firebase.initializeApp(config);

